export enum NbnServiceabilityFail {
  serviceTypeUnavailableSatellite = 'Service type unavailable - Satellite',
  addressUnserviceableHfc = 'Address unserviceable - HFC',
  addressUnserviceable = 'Address unserviceable - 500',
  unableToRetrieveNbnProducts = 'Unable to retrieve NBN products',
  failedToCompleteHttpRequest = 'Failed to complete HTTP request',
  multipleMatchingAddresses = 'Multiple matching addresses'
}
